<template>
  <div class="counter">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="158.536"
      height="159.18"
      viewBox="0 0 158.536 159.18"
    >
      <path
        d="M158.006,139.948l-.819,0,.21-60.986h0l0-.333a74.716,74.716,0,0,0-6.017-29.371l0-.01,0,.011a77.743,77.743,0,0,0-142.874-.1h0a75.424,75.424,0,0,0-6.16,29.7h0l-.21,60.986-.819,0,.819-.016a20.872,20.872,0,0,0,4.287,12.249l.015.02.015.021a13.237,13.237,0,0,0,10.329,5.84l-.041.819,0-.819,5.752.015,0,.819-.023-.819a12.314,12.314,0,0,0,6.065-1.8l.007,0,.008,0a18.746,18.746,0,0,0,5.039-4.3l0,0c1.181-1.419,3.529-3.93,6.687-3.973h0c2.991.056,5.193,2.618,6.654,4.377l0,0,0,0A15.079,15.079,0,0,0,58.02,158l-.041.819,0-.819,3.907,0h.007c4.287.029,8.668-3.219,10.964-6.012l.631.524-.673-.469a9.4,9.4,0,0,1,6.543-3.955l.051-.007h.052c2.875.052,5,2.436,6.581,4.318l0,0,0,0A15.028,15.028,0,0,0,97,158.019l-.043.819v-.819h4.1c4.287.029,8.668-3.219,10.964-6.012l.629.523-.672-.469a9.418,9.418,0,0,1,6.543-3.955l.051-.007h.052c2.875.056,5,2.436,6.581,4.322l0,0,0,0a15.02,15.02,0,0,0,10.954,5.611l-.043.819,0-.819,5.97,0h-.008a11.359,11.359,0,0,0,5.725-1.61h0v0a17.42,17.42,0,0,0,4.824-4.261l0,0,0-.007a20.592,20.592,0,0,0,4.543-12.237l.817.028-.819,0,.819,0,.819.026a22.215,22.215,0,0,1-4.9,13.21l-.639-.513.647.5a19.074,19.074,0,0,1-5.277,4.662h0a13,13,0,0,1-6.551,1.843h0l-6,0-.02,0a16.666,16.666,0,0,1-12.15-6.223l.639-.511-.632.519c-1.494-1.861-3.5-3.771-5.316-3.722v-.819l.1.813a7.778,7.778,0,0,0-5.4,3.267l-.02.028-.023.026c-2.534,3.029-7.124,6.576-12.224,6.605H96.941l-.021,0a16.677,16.677,0,0,1-12.15-6.223l.639-.513-.632.519c-1.494-1.859-3.5-3.771-5.316-3.72l0-.819.1.813a7.763,7.763,0,0,0-5.4,3.265l-.02.029-.023.026c-2.534,3.027-7.124,6.574-12.224,6.6h-.008l-3.927,0-.021,0A16.725,16.725,0,0,1,45.653,153.3l.642-.508-.636.514c-1.37-1.736-3.483-3.827-5.381-3.769h0c-2.171-.044-4.369,2.046-5.417,3.368v0l0,0a20.4,20.4,0,0,1-5.481,4.67l-.413-.708.428.7a13.976,13.976,0,0,1-6.871,2.041h-.013l-5.784-.015-.018,0a14.878,14.878,0,0,1-11.61-6.563l.68-.457-.65.5A22.516,22.516,0,0,1,.5,139.86l0-.01L.71,78.856v0A77.131,77.131,0,0,1,7,48.513H7a79.4,79.4,0,0,1,145.885.1h0a76.328,76.328,0,0,1,6.15,30.015l0,.339h0l-.21,61v.011Z"
        transform="translate(-0.5 -0.5)"
        fill="#50fcea"
      />
      <template v-if="time != null">
        <text
          v-if="time < 10"
          font-size-adjust="0.58"
          transform="scale(1)"
          class="time"
          x="50%"
          y="55%"
          dominant-baseline="middle"
          text-anchor="middle"
        >
          0{{ time }}
        </text>
        <text
          v-if="time >= 10"
          font-size-adjust="0.58"
          transform="scale(1)"
          class="time"
          x="50%"
          y="55%"
          dominant-baseline="middle"
          text-anchor="middle"
        >
          {{ time }}
        </text>
      </template>
    </svg>
    <p v-if="unit" class="unit">{{ unit }}</p>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'Counter',
  props: {
    time: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: '',
    },
  },
});
</script>

<style scoped>
.counter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: calc(25% - 20px);
  max-width: 100px;
}

.counter svg {
  width: 100%;
  height: auto;
  max-height: 100px;
}

.time {
  font-size: 70px;
  fill: white;
}
</style>
